export default __webpack_public_path__ + "static/media/623.9f9d244a.gif";